<template>
  <div v-if="! $mq.lg && isOpen" class="fixed w-full top-0 bg-white overflow-y-scroll h-screen z-50">
    <div class="sticky top-0 z-50 bg-white font-bold flex justify-between items-center py-20 px-20 border-b border-gray">
      <span>Filter</span>
      <button
        aria-label="dismiss"
        class="text-dark-gray text-center focus:outline-none"
        @click="toggle">
        <i class="fal fa-times fa-lg"></i>
      </button>
    </div>

    <div class="overflow-auto filterContent">
      <div class="px-20 py-32 border-b border-light-gray-4">
        <span class="text-16">Keyword Search</span>
        <search-form
          class="ml-auto pt-20 pb-14 leading-none"
          placeholder="Type your search"
          @toggled="redirect"
          :default-value="defaultSearchValue"
          inputClass="rounded-md py-16 text-14 focus:outline-none">
          <template #icon="{ term }">
            <div class="absolute right-0 center-y mr-12 cursor-pointer">
              <div
                class="px-10 py-8 text-white bg-orange rounded-md"
                @click="redirect({ term: term })">
                <i class="far fa-search text-sm"></i>
              </div>
            </div>
          </template>
        </search-form>
      </div>

      <div v-for="(filter, key) in sidebarFilters" class="filterOptions">
        <the-filter-mobile-items
          :filter="filter"
          :filter-key="key">
        </the-filter-mobile-items>
      </div>
    </div>

    <!-- <div class="w-full h-fit py-20 z-50 bg-white drop-shadow-md fixed bottom-0"> -->
    <div class="w-full h-fit py-20 z-50 bg-white drop-shadow-md fixed bottom-0">
      <div class="flex px-20 justify-between items-center">
        <button
          class="focus:outline-none text-14"
          @click="queryActions.clear">
          Clear all
        </button>
        <button
          class="py-18 px-22 text-14 text-white uppercase rounded-md bg-orange focus:outline-none"
          @click="toggle">
          Show Results
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import TheFilterMobileItems from './TheFilterMobileItems'
import SearchForm from './Universal/SearchForm.vue'
import { FILTERS } from '../support/constants'
import pick from 'lodash/pick'

export default {
  components: {
    TheFilterMobileItems,
    SearchForm,
  },

  data () {
    return {
      isOpen: false,
    }
  },

  inject: ['filters', 'query', 'queryActions'],

  methods: {
    toggle () {
      if (this.isOpen) {
        document.body.style.overflow = 'scroll';
      }

      if (! this.isOpen) {
        document.body.style.overflow = 'hidden';
      }

      this.isOpen = ! this.isOpen
    },

    redirect(search) {
      if (search.term == null || search.term === "") {
        window.location.assign("/artworks");
      }

      if (search.term != null && search.term !== "") {
        window.location.assign(`/artworks?search=${search.term}`);
      }
    },
  },

  created() {
    window.TheFilterPanelMobile = this
  },

  computed: {
    sidebarFilters () {
      return pick(this.filters, FILTERS)
    },

    defaultSearchValue() {
      return new URLSearchParams(window.location.search).get("search") ?? null;
    },
  },
}
</script>

<style>
  .filterContent {
    height: calc(100vh - 150px);
  }
 .drop-shadow-md {
  box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.09);
 }
 .filterOptions:not(:last-child) {
    padding-bottom: 0px;
    border-bottom: 1px solid #E5E0DF;
  }

  @media (max-height: 950px) {
    .filterOptions:last-child {
      margin-bottom: 50px;
    }
  }

  @media (max-height: 750px) {
    .filterOptions:last-child {
      margin-bottom: 100px;
    }
  }
</style>
